"use strict";

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("ChargeToday");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

var ChargeToday = React.createClass({
	propTypes: {
		className: React.PropTypes.string,
		isDesignMode: React.PropTypes.bool,
		cartItemId: React.PropTypes.string,
		theme: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string
	},

	handleChange: function (event) {
		CheckoutActions.setDonationChargeToday(this.props.cartItemId, event.currentTarget.checked);
		if (!this.props.isDesignMode) {
			CheckoutActions.updateDonation(this.props.cartItemId);
		}
	},

	getStateFromStore: function () {
		return {
			isChargeToday: CheckoutStore.getDonationChargeToday(this.props.cartItemId)
		};
	},

	_onChange: function () {
		this.setState(this.getStateFromStore());
	},

	componentDidMount: function () {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	},

	componentWillUnmount: function () {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationChargeToday(this.props.cartItemId, false);
		}
	},

	getDefaultProps: function () {
		return {};
	},

	getInitialState: function () {
		return this.getStateFromStore();
	},

	render: function () {
		var startDate = CheckoutStore.getDonationStartDate(this.props.cartItemId);
		var recurringStartsToday = startDate.isSame(new Date(), "day");
		var isChargeToday = this.state.isChargeToday || recurringStartsToday;
		var isChargeTodayRequired = CheckoutStore.getIsDonationChargeTodayRequired(this.props.cartItemId);
		var isDisabled = !this.props.isDesignMode && (
			isChargeTodayRequired ||
			CheckoutStore.getDonationFrequency(this.props.cartItemId) === "O" ||
			recurringStartsToday
		);

		return (
			<span
				data-react-component-name="ChargeToday"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<input
					type="checkbox"
					className={classNames(this.props.className, {disabled: isDisabled})}
					data-override-classes={this.props.className}
					checked={isChargeToday}
					onChange={this.handleChange}
					disabled={isDisabled}
				/>
			</span>
		);
	}
});

module.exports = ChargeToday;



// WEBPACK FOOTER //
// ./Javascript/checkoutComponents/ChargeToday.jsx